<template>
    <div>
      <!--h1>{{ msg }}</h1>
      <button v-on:click="check()">check</button>
      <p> {{ randomnumber }} </p>

      <b-input type="email" width="300"></b-input>
      <b-input type="password"></b-input>
      <b-button size="sm">sdd</b-button-->

      <Login />

     
    </div>
</template>

<script>
import axios from 'axios'
import Login from '@/components/importables/Login'
export default {
  name: 'Index',
  components: {Login},
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      randomnumber: null
    }
  },
  methods: {
    check: function(){
      let that = this
      const path = "/api/getnumber/"
      axios.get(path)
        .then(res => {
          if (res.data.randomnumber) {
              that.randomnumber = res.data.randomnumber
            }
          }
        )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue